export const ONBOARDING = 'onboarding';
export const VERIFICATION = 'verification';
export const DASHBOARD = 'dashboard';
export const COMMON = 'common';
export const ANALYTICS = 'analytics';
export const SETTINGS = 'settings';

export const AVAILABLE_LANGUAGES = {
  en: 'en',
  ar: 'ar'
};

export const DEFAULT_LNG = AVAILABLE_LANGUAGES.en;
export const LANGUAGES = [AVAILABLE_LANGUAGES.en /*AVAILABLE_LANGUAGES.ar*/];
export const DEFAULT_NS = 'common';
export const COOKIE_NAME = 'portalLang';
export const DTD_AUTO_REFRESH_INTERVAL_IN_MS = 25000;
export const TRACK_CASE = 'trackCase';
export const ADVANCE_SEARCH = 'advanceSearch';
